import { useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import './login.css'

function PasswordReset() {
  const {
    isAuthenticated,
    requiresPasswordReset,
    resetPassword,
    logout,
    user,
  } = useAuth()
  const navigate = useNavigate()
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  if (!isAuthenticated) return <Navigate to='/login' replace />
  if (!requiresPasswordReset) return <Navigate to='/dashboard' replace />

  const reason =
    user?.password_reset_reason === 'password_expired'
      ? 'Your password is more than three months old.'
      : 'Your account requires a password change before continuing.'

  const submit = async (event) => {
    event.preventDefault()
    setError('')
    if (newPassword !== confirmPassword) {
      setError('New password and confirmation do not match.')
      return
    }

    setIsSubmitting(true)
    try {
      await resetPassword(currentPassword, newPassword, confirmPassword)
      navigate('/dashboard', { replace: true })
    } catch (resetError) {
      setError(resetError.message)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <main className='login-page'>
      <section className='login-card' aria-labelledby='password-reset-title'>
        <div className='login-card__brand'>
          <span className='login-card__mark'>
            <img src='/logo1.jpg' alt='' />
          </span>
          <span>Buck Press</span>
        </div>
        <div className='login-card__intro'>
          <span className='app-content__eyebrow'>Account security</span>
          <h1 id='password-reset-title'>Reset your password</h1>
          <p>{reason}</p>
        </div>
        <form className='login-form' onSubmit={submit}>
          <label>
            Current password
            <input
              type='password'
              value={currentPassword}
              onChange={(event) => setCurrentPassword(event.target.value)}
              autoComplete='current-password'
              required
            />
          </label>
          <label>
            New password
            <input
              type='password'
              value={newPassword}
              onChange={(event) => setNewPassword(event.target.value)}
              autoComplete='new-password'
              minLength='8'
              required
            />
          </label>
          <label>
            Confirm new password
            <input
              type='password'
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              autoComplete='new-password'
              minLength='8'
              required
            />
          </label>
          {error && (
            <p className='login-form__error' role='alert'>
              {error}
            </p>
          )}
          <button type='submit' disabled={isSubmitting}>
            {isSubmitting ? 'Updating password...' : 'Update password'}
            <span aria-hidden='true'>→</span>
          </button>
        </form>
        <button
          className='login-card__secondary-action'
          type='button'
          onClick={logout}
        >
          Sign out
        </button>
      </section>
    </main>
  )
}

export default PasswordReset
